
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/image",
      function () {
        return require("private-next-pages/search/image/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/image"])
      });
    }
  